// The Discard tool's one gesture: a press, then whatever the drag crosses.
//
// It owns no command of its own — track goes to `eraseBelt` and a building to
// `demolish`, each of which already says its own refusals — so the inspector's
// button and this tool cannot disagree about what taking a building down needs.
//
// **A press on a building ends the gesture.** `demolish` hands the clock on,
// and in hot-seat the seat goes with it: the rest of the drag would be lifting
// the *other* player's track. Refused or not, a click on a building was about
// the building. `core.over` is that fact; it was a ref.

import type { SessionCore } from "./core";
import { discardAt } from "./discard";

export function discardVerb(
  core: SessionCore,
  deps: { eraseBelt(square: number): void; demolish(square: number): void }
) {
  return (square: number, press: boolean) => {
    if (press) core.over = false;
    if (core.over) return;

    const found = discardAt(core.state.industry, square, core.localSide, press);
    if (found.kind === "part") {
      deps.eraseBelt(square);
      return;
    }
    if (found.kind === "nothing") return;

    core.over = true;
    if (found.kind === "refuse") core.setRefusal(found.why);
    else deps.demolish(square);
    core.changed();
  };
}
